import { Spinner, UIHeading4 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';
import { Wrapper } from '../Wrapper';

export const Skeleton: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <Wrapper>
      <UIHeading4>{children}</UIHeading4>
      <div className={styles['preloader']}>
        <Spinner size={24} />
      </div>
    </Wrapper>
  );
};

Skeleton.displayName = 'Skeleton';
